<template>
    <div>
        <multiselect
            ref="gameSelector"
            class="form-control"
            v-model="selectedGames"
            :options="gameOptions"
            :track-by="'key'"
            :multiple="true"
            :taggable="true"
            label="value"
            @select="gameSelect"
            @remove="gameRemove"
        >
            <template slot="tag" slot-scope="props">
                <span class="multiselect__tag">
                    <span>{{ props.option.value }}</span>
                    <i
                        aria-hidden="true"
                        tabindex="1"
                        @keydown.enter.prevent="
                            removeSelectedGameElement(props.option)
                        "
                        @mousedown.prevent="
                            removeSelectedGameElement(props.option)
                        "
                        class="multiselect__tag-icon"
                    ></i>
                    <!-- Customs -->
                    <div
                        style="color:blue; display: inline-block;"
                        v-if="props.option.key === 'video-watching'"
                        @click.prevent="addVideoUrl(props.option)"
                    >
                        <template v-if="props.option.url !== null">
                            ({{ props.option.url.slice(0, 10) }})
                        </template>
                        <template v-else>
                            (Video ekle)
                        </template>
                    </div>
                    <div
                        style="color:blue; display: inline-block;"
                        v-if="props.option.key === 'listen'"
                        @click.prevent="showListenModalEvent(props.option)"
                    >
                        (Karakter metni ekle)
                    </div>
                    <div
                        style="color:blue; display: inline-block;"
                        v-if="props.option.key === 'location-verification'"
                        @click.prevent="addLocation(props.option)"
                    >
                        <template v-if="props.option.location !== null">
                            ({{ props.option.location }})
                        </template>
                        <template v-else>
                            (Lokasyon ekle)
                        </template>
                    </div>
                    <div
                        style="color:blue; display: inline-block;"
                        v-if="props.option.key === 'item-verification'"
                        @click.prevent="addArtefact(props.option)"
                    >
                        <template v-if="props.option.artefacts.length > 0">
                            ({{ props.option.artefacts.length }} Eser seçili)
                        </template>
                        <template v-else>
                            (Herhangi bir eser seçilmemiş)
                        </template>
                    </div>
                    <!-- Customs -->
                </span>
            </template>
        </multiselect>
        <vue-final-modal
            :key="'modal-1'"
            v-model="showSelectArtefactModal"
            classes="modal-container"
            content-class="modal-content"
        >
            <span class="modal__title">
                <slot name="title">
                    Lütfen eser seçiniz
                </slot>
            </span>

            <div class="modal__content">
                <artefact-select-list
                    v-if="showSelectArtefactModal"
                    :create-hidden-input="false"
                    :selected-artefacts="selectedArtefactForGame"
                    @update-artefacts="updateArtefacts"
                ></artefact-select-list>
            </div>
        </vue-final-modal>
        <vue-final-modal
            :key="'modal-2'"
            v-model="showListenModal"
            classes="modal-container"
            content-class="modal-content"
            v-if="showListenModal"
        >
            <span class="modal__title">
                <slot name="title">
                    Lütfen karakter metini giriniz.
                </slot>
            </span>

            <div class="modal__content">
                <div v-for="(language, lnKey) in languages" :key="lnKey">
                    <div class="row">
                        <label class="col-sm-1 col-form-label">
                            Metin [{{ language.key }}]
                            <p
                                v-if="language.key === 'tr_TR'"
                                class="fs-6 text-danger"
                            >
                                *Zorunlu
                            </p>
                        </label>

                        <div class="col-sm-11">
                            <div class="form-group">
                                <textarea
                                    v-model="selectedOption.text[language.key]"
                                    type="text"
                                    rows="5"
                                    class="form-control"
                                    name="language"
                                    @change="
                                        setCharacterMessageChanged(
                                            selectedOption,
                                            language.key
                                        )
                                    "
                                ></textarea>
                                <span
                                    v-if="language.key !== 'tr_TR'"
                                    class="fs-6 text-info"
                                    >Bu alanı boş bırakmanız halinde metin
                                    Google Translate'den otomatik
                                    çevrilir.</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-final-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import ArtefactSelectList from "./artefact-select-list.vue";
import { $vfm, VueFinalModal, ModalsContainer } from "vue-final-modal";

export default {
    props: ["games"],
    components: {
        Multiselect,
        VueFinalModal,
        ModalsContainer,
        ArtefactSelectList
    },
    computed: {
        languages() {
            let final = [];

            const languages = JSON.parse(
                process.env.MIX_LANGUAGES.replaceAll("'", '"')
            );

            const placeholders = JSON.parse(
                process.env.MIX_LANGUAGES_PLACEHOLDERS.replaceAll("'", '"')
            );

            for (let i = 0; i < languages.length; i++) {
                final.push({
                    key: languages[i],
                    values: placeholders[i]
                });
            }

            return final;
        },
        selectedArtefactForGame() {
            if (this.selectedGames && this.selectedGames.length > 0) {
                let ItemVerificationGame = this.selectedGames.filter(
                    i => i.key === "item-verification"
                );
                return ItemVerificationGame[0].artefacts;
            }

            return [];
        }
    },
    data() {
        return {
            selectedGames: [],
            gameOptions: [
                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "listen",
                    value: "Dinle",
                    text: {},
                    updated: [],
                    point: 50,
                    order: 1
                },
                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "item-verification",
                    value: "Eser Doğrulama",
                    artefacts: [],
                    point: 150,
                    order: 2
                },
                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "memory-photo",
                    value: "Hatıra Fotoğrafı Çektir",
                    point: 100,
                    order: 3
                },
                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "location-verification",
                    value: "Konum Doğrulama",
                    location: null,
                    point: 50,
                    order: 4
                },
                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "video-watching",
                    value: "Video İzleme",
                    url: null,
                    point: 100,
                    order: 5
                },

                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "give-star",
                    value: "Yıldız Verme",
                    point: 50,
                    order: 6
                },
                {
                    id: Math.random()
                        .toString(36)
                        .slice(2, 9),
                    key: "make-comment",
                    value: "Yorum Yapma",
                    point: 50,
                    order: 7
                }
            ],
            selectedOption: null,
            showSelectArtefactModal: false,
            showListenModal: false
        };
    },
    methods: {
        gameSelect() {
            this.$emit("update-games", this.selectedGames);
        },
        gameRemove() {
            this.$emit("update-games", this.selectedGames);
        },
        removeSelectedGameElement: function(element) {
            this.$refs.gameSelector.removeElement(element);
        },
        addVideoUrl(option) {
            let url = prompt(
                "Lütfen bir video adresi giriniz",
                option.url || ""
            );
            if (url != null || url != "") {
                option.url = url;
            }
        },
        showListenModalEvent(option) {
            this.showListenModal = true;
            this.selectedOption = option;
        },
        addLocation(option) {
            let location = prompt(
                "Lütfen konumu enlem,boylam olarak giriniz. Örn: 42.912,14.292",
                option.location || ""
            );

            if (this.isLatLongValid(location)) {
                if (location != null || location != "") {
                    option.location = location;
                }
            } else {
                alert(
                    "Yanlış lokasyon formatı. Lütfen lokasyon formatına dikkat ediniz. Örn: 42.912,14.292"
                );
            }
        },
        addArtefact(option) {
            this.showSelectArtefactModal = true;
            this.selectedOption = option;
        },
        updateArtefacts(artefacts) {
            this.$emit("update-games", this.selectedGames);
            this.selectedOption.artefacts = artefacts;
        },
        isLatLongValid(value) {
            if (value === "" || value === null) return false;
            if (value.indexOf(",") === -1) return false;

            let splitDots = value.split(".");
            if (splitDots.length === value.length) return false;
            if (splitDots.length !== 3) return false;

            return true;
        },
        setCharacterMessageChanged(selectedOption, language) {
            //if not exists, add it
            if (selectedOption.updated.findIndex(o => o == language) === -1) {
                if (selectedOption.text[language] != "") {
                    selectedOption.updated.push(language);
                }
            }

            // if text is empty, remove from updated
            Object.keys(selectedOption.text).forEach(lang => {
                if (selectedOption.text[lang] == "") {
                    selectedOption.updated = selectedOption.updated.filter(
                        o => o !== lang
                    );
                }
            });
        }
    },
    mounted() {
        this.selectedGames = this.games;
    }
};
</script>

<style scoped>
>>> .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
>>> .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90%;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
    height: 300px;
}
>>> .modal__title {
    margin: 0 2rem 0 0;
    font-size: 1.5rem;
    font-weight: 700;
}
>>> .modal__content {
    flex-grow: 1;
    overflow-y: auto;
}
>>> .modal__action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem 0 0;
}
>>> .modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// resources/vue/story-visiting-point-game-select.vue